// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import markerPin04Icon from "@/assets/icons/marker-pin-04.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MarkerPin04IconProps = Omit<IconProps, "name">;

export function MarkerPin04Icon(props: MarkerPin04IconProps): React.ReactNode {
  return <Icon name={markerPin04Icon} {...props} />;
}
